import React from 'react'
import { Box, Card, CardActionArea, Typography } from '@mui/material'
import { PlainLink as Link } from 'infrastructure/routing'

type LandingCard = {
  title: string
  description: string
  path: string
  color: string
}

const cards: LandingCard[] = [
  {
    title: 'CROSSWALKS',
    description: 'View existing crosswalks or upload new ones',
    path: '/scope_and_sequence/crosswalks',
    color: '#7C3AED',
  },
  {
    title: 'COURSE BUILDER',
    description: 'Create a new state adoption course',
    path: '/scope_and_sequence/parse',
    color: '#2563EB',
  },
  {
    title: 'LESSON MAPPINGS',
    description: 'View previous lesson mappings \u00b7 Reference tool',
    path: '/scope_and_sequence/lesson_mappings',
    color: '#16A34A',
  },
  {
    title: 'STANDARDS',
    description:
      'Verify standards imported from EdGate \u00b7 Dev verification tool',
    path: '/scope_and_sequence/frameworks',
    color: '#EA580C',
  },
]

export function Landing() {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" fontWeight={700} sx={{ mb: 4 }}>
        State Adoption Course Builder
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {cards.map((card) => (
          <LandingCardItem key={card.title} card={card} />
        ))}
      </Box>
    </Box>
  )
}

function LandingCardItem({ card }: { card: LandingCard }) {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        backgroundColor: '#f9fafb',
      }}
    >
      <CardActionArea component={Link} to={card.path}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
          }}
        >
          <Box
            sx={{
              width: 4,
              flexShrink: 0,
              backgroundColor: card.color,
              borderRadius: '4px 0 0 4px',
            }}
          />
          <Box sx={{ p: 2.5, pl: 2 }}>
            <Typography variant="subtitle1" fontWeight={700}>
              {card.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {card.description}
            </Typography>
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  )
}
